import { getBasePath } from '@prophecy/utils/history';
import { matchPath } from 'react-router-dom';

import { Private_Routes, VAPP_Private_Routes } from './url';

export function isEnterpriseIDERoute() {
  return Boolean(matchPath(`${getBasePath()}${Private_Routes.SQL_IDE.url}`, window.location.pathname));
}

export function isVerticalAppIDERoute() {
  return Boolean(matchPath(`${getBasePath()}${VAPP_Private_Routes.Project_Detail.url}`, window.location.pathname));
}

export function isSqlIDE() {
  return isEnterpriseIDERoute() || isVerticalAppIDERoute();
}
